import * as _ from 'lodash';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  takeUntil,
  tap,
} from 'rxjs/operators';
import { InvoiceViewType } from '@app/core/models/invoices/invoice-view-type.model';
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormGroup,
  Validators,
  UntypedFormArray,
  ValidatorFn,
  UntypedFormBuilder,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { InvoiceDetailModel } from '@app/core/models/invoices/invoice-detail.model';
import { RejectionFlags } from '@app/core/models/referentials/rejection-flag.model';
import { InvoiceService } from '@app/core/services/invoice.service';
import { MultiSelectModel } from '@app/shared/models/multi-select.model';
import { InvoiceTraceabilityModel } from '@app/core/models/invoices/traceability/invoice-traceability.model';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';
import { UploadComponent } from '@app/shared/components/upload/upload.component';
import { InvoiceActionType } from '@app/core/models/invoices/invoice-action-type.model';
import { DecimalPipe } from '@angular/common';
import { AssetService } from '@app/core/services/asset.service';
import { ReferentialItem } from '@app/core/models/shared/referential-item.model';
import { RecipientEntitiesService } from '@app/core/services/recipient-entities.service';
import { CommonService } from '@app/core/services/common.service';
import { InvoiceInjection } from '@app/core/models/invoices/injection/invoice-injection.interface';
import { ImportMissingInvoiceNumberModel } from '@app/core/models/imports/import-missing-invoice-number.model';
import { AccessRequirement } from '@app/core/models/access-requirement.model';
import { InvoiceAssignmentGroupModel } from '@app/core/models/invoices/invoice-assignment-group.model';
import { GroupTypeModel } from '@app/core/models/groups/group-type.model';
import { ConfigService } from '@app/core/config/config.service';
import { SupplierService } from '@app/core/services/supplier.service';
import { SearchCriteria } from '@app/core/models/supplier/SearchCriteria';
import { SupplierModel } from '@app/core/models/supplier/supplier.model';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { GroupService } from '@app/core/services/group.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ReferentialsModel } from '@app/core/models/referentials/referentials.model';
import { Operation } from '@app/core/models/datawell/operation.model';
import { DatawellService } from '@app/core/services/datawell.service';
import { SearchParam } from '@app/core/models/datawell/searchParam.model';
import { Commande } from '@app/core/models/datawell/commande.model';
import { NumberCommaToDotFormatPipe } from '@app/shared/pipes/number-comma-to-dot-format.pipe';
import { SearchGlobalParam } from '@app/core/models/datawell/searchGlobalParam.model';
import { SearchParamOperator } from '@app/core/enums/searchParamOperator.enum';
import { Marche } from '@app/core/models/datawell/marche.model';
import { MatDatepicker } from '@angular/material/datepicker';
import { IntervenantFunction } from '@app/core/enums/intervenantFonction.enum';
import { ExpenseFamilyTypeRef } from '@app/core/models/referentials/expense-family-type.model';
import { DeductionTypeRef } from '@app/core/models/referentials/deduction-type.model';
import { DelegationOverride } from '@app/core/models/datawell/delegations.model';
import { toNumber } from 'lodash';
import { InvoicePPRTypeEnum } from '@app/core/enums/invoicePPRType.enum';
import { InvoiceAmountCalc } from '@app/core/models/invoices/invoice-amount-calc.model';
import { InvoiceInformationBDC } from '@app/core/models/invoices/invoice-information-bdc.model';
import { BuildFormGroupsService } from '@app/core/services/manageInvoice/build-form-groups.service';
import { InvoiceDeductionComponent } from './invoice-panels/invoice-deduction/invoice-deduction.component';
import { InvoiceAmendmentComponent } from './invoice-panels/invoice-amendment/invoice-amendment.component';
import { InvoiceExpenseComponent } from './invoice-panels/invoice-expense/invoice-expense.component';
import { InvoiceParameters } from '@app/core/models/invoices/invoice-parameters.model';
import { InvoiceDelegationComponent } from './invoice-panels/invoice-delegation/invoice-delegation.component';
import { CommonLibraryService } from '@app/core/services/manageInvoice/common-library.service';
import { Avenant } from '@app/core/models/datawell/avenant.model';
import { InvoiceExpenseDetail } from '@app/core/models/invoices/invoice-expense.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ExpenseLibraryService } from '@app/core/services/manageInvoice/expense-library.service';
import { LocaleSettings } from 'primeng/calendar';

@Component({
  selector: 'app-invoice-detail',
  templateUrl: './invoice-detail.component.html',
  styleUrls: ['./invoice-detail.component.scss'],
  providers: [],
})
export class InvoiceDetailComponent
  extends CommonService
  implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked
{
  calendar_fr: LocaleSettings = {
    monthNames: [
      'janvier',
      'février',
      'mars',
      'avril',
      'mai',
      'juin',
      'juillet',
      'août',
      'septembre',
      'octobre',
      'novembre',
      'décembre',
    ],
    monthNamesShort: [
      'janv.',
      'févr.',
      'mars',
      'avr.',
      'mai',
      'juin',
      'juil.',
      'août',
      'sept.',
      'oct.',
      'nov.',
      'déc.',
    ],
    dayNames: [
      'dimanche',
      'lundi',
      'mardi',
      'mercredi',
      'jeudi',
      'vendredi',
      'samedi',
    ],
    dayNamesShort: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
    weekHeader: 'Sem.',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 1,
  };

  invoiceViewType: string;
  invoiceDetailModel: InvoiceDetailModel;
  invoiceTraceability: InvoiceTraceabilityModel;
  invoiceDetailForm: UntypedFormGroup;
  injection: InvoiceInjection = null;

  unsubscribe$: Subject<boolean> = new Subject<boolean>();

  submitted = true;
  dropDownSettingsRecipientEntities: any;
  dropDownDataRecipientEntities = [];
  selectedRecipientEntity = [];
  dropDownSettingsAssets: any;
  dropDownDataAssets = [];
  selectedAsset = [];
  fileToUpload: File = null;

  isFormUpdated: boolean = false;
  canUpdateVoucher: boolean = false;
  showValidationButton: boolean = false;
  invoiceFormFile: File;
  pristineFormValue: any = null;
  isWaitingInvoice: boolean = false;

  supplierSearchEvent$: Subject<string> = new Subject<string>();
  suppliers: SupplierModel[];
  dropDownSettingsSuppliers: IDropdownSettings;
  supplierId: string;

  thirdPartySearchEvent$: Subject<string> = new Subject<string>();
  thirdParty: SupplierModel[];
  dropDownSettingsThirdParty: IDropdownSettings;
  thirdPartyIdByTradeId: string;

  delegatesSearchEvent$: Subject<string> = new Subject<string>();
  delegates: SupplierModel[];
  dropDownSettingsDelegates: IDropdownSettings;

  creditorsSearchEvent$: Subject<string> = new Subject<string>();
  creditors: SupplierModel[];
  dropDownSettingsCreditors: IDropdownSettings;

  dropDownDataVat = [];
  dropDownSettingsVat: any;

  dropDownDataExpenseFamilyType: ExpenseFamilyTypeRef[] = [];
  dropDownDataExpenseFamilyTypeAll: ExpenseFamilyTypeRef[] = [];
  dropDownSettingsExpenseFamilyType: any;

  dropDownDataInvoicePPRType = [];
  dropDownSettingsInvoicePPRType: any;

  operationSearchEvent$: Subject<string> = new Subject<string>();
  dataOperations: Operation[] = [];
  dropDownSettingsOperations: any;

  dataCommandes: Commande[];
  dropDownSettingsCommandes: any;

  dataMarches: Marche[];
  selectedMarche: Marche;
  selectedTrade: [];
  dropDownSettingsMarches: any;

  dropDownDataAvenant: Avenant[] = [];
  dropDownSettingsAvenant: any;

  selectedDelegations: DelegationOverride[] = [];

  dropDownDataDeductionType = [];
  dropDownDataDeductionTypeAll: DeductionTypeRef[] = [];
  dropDownSettingsDeductionType: any;

  editedDropdowns: string[] = [];

  invoiceDetailAmountCalc: InvoiceAmountCalc = new InvoiceAmountCalc();
  invoiceSumTaxIncluded: string;
  invoiceSumMarketWithAmendment: string;

  invoiceDetailInformationBDC: InvoiceInformationBDC =
    new InvoiceInformationBDC();
  invoiceParams: InvoiceParameters = new InvoiceParameters();

  isCumulSituationChanged: boolean = false;
  isReturnOperationalComment: boolean = false;
  eValuaRaisonSocialMandatory: boolean = false;

  eValuaSIRETValueOnStartup: string;

  private readonly field_read = 'black';
  private readonly field_change = '#0c3982';
  private readonly field_disabled = '#8c8c8c';

  @ViewChild(UploadComponent) uploadComponent: UploadComponent;

  @ViewChild(InvoiceExpenseComponent) childExpense: InvoiceExpenseComponent;

  @ViewChild(InvoiceDeductionComponent)
  childDeduction: InvoiceDeductionComponent;

  @ViewChild(InvoiceAmendmentComponent)
  childAmendment: InvoiceAmendmentComponent;

  @ViewChild(InvoiceDelegationComponent)
  childDelegation: InvoiceDelegationComponent;

  constructor(
    private route: ActivatedRoute,
    private InvoiceService: InvoiceService,
    protected assetService: AssetService,
    protected recipientEntityService: RecipientEntitiesService,
    private router: Router,
    private decimalPipe: DecimalPipe,
    public dialog: MatDialog,
    private multiSelectModel: MultiSelectModel,
    private authenticationInfoService: AuthenticationInfoService,
    protected config: ConfigService,
    private supplierService: SupplierService,
    private datawellService: DatawellService,
    private groupService: GroupService,
    private numberFormatPipe: NumberCommaToDotFormatPipe,
    public commonLibrary: CommonLibraryService,
    private formGroupBuilder: BuildFormGroupsService,
    protected formBuilder: UntypedFormBuilder,
    private cdref: ChangeDetectorRef,
    private ngxService: NgxUiLoaderService,
    public expenseLibrary: ExpenseLibraryService
  ) {
    super(assetService, recipientEntityService);
    this.invoiceDetailModel = new InvoiceDetailModel();
    this.invoiceDetailModel.Attachments = [];
    this.invoiceDetailModel.RejectionFlagId = RejectionFlags.None;
    if (this.config !== undefined) {
      this.invoiceParams.isVatNumberComplianceEnabled =
        this.config.environnement.vatNumberComplianceIsEnabled;
    }
  }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      if (!_.isNil(data.invoice)) {
        this.invoiceDetailModel = data.invoice;
        this.eValuaSIRETValueOnStartup = this.invoiceDetailModel.SupplierEvaluaSIRET;
        
        this.invoiceParams.isDuplicateInvoice =
          !_.isNil(this.invoiceDetailModel) &&
          this.invoiceDetailModel.RejectionFlagId === RejectionFlags.Duplicate;
        if (!_.isNil(this.invoiceDetailModel.RecipientEntityId)) {
          this.selectedRecipientEntity = [
            new ReferentialItem(
              this.invoiceDetailModel.RecipientEntityId,
              this.invoiceDetailModel.RecipientEntityName
            ),
          ];
        }
        if (
          !_.isNil(this.invoiceDetailModel.PrimaryReference) &&
          this.invoiceDetailModel.PrimaryReference !== ''
        ) {
          this.selectedAsset = [
            new ReferentialItem(0, this.invoiceDetailModel.PrimaryReference),
          ];
        }
      }

      if (!_.isNil(data.missingInvoiceNumber)) {
        const importMissingNumberDocument: ImportMissingInvoiceNumberModel =
          data.missingInvoiceNumber;
        this.injection = {
          ImportDate: importMissingNumberDocument.ImportDate,
          ImportMissingInvoiceNumberDocumentId: importMissingNumberDocument.Id,
          InvoiceDocuwareDocumentId: importMissingNumberDocument.DocumentId,
          InvoiceDocuwareDocumentFileName:
            importMissingNumberDocument.PdfFileName,
          OcrDate: importMissingNumberDocument.OcrDate,
          Source: importMissingNumberDocument.Source,
        };
        this.invoiceParams.isInjection = true;
      }
      const referentials: ReferentialsModel = data.referentials;
      this.setReferential(referentials);

      this.invoiceViewType = data.InvoiceViewType;

      if (
        this.invoiceParams.isInjection ||
        data.invoiceViewType == InvoiceViewType.MANUAL
      ) {
        this.invoiceViewType = data.invoiceViewType;
      }

      this.invoiceParams.canCancelProcess = data.canCancelProcess ?? false;
      this.invoiceParams.canCreateInPPR =
        this.isPPRDirectInvoice || this.isPPRWorkingSituation;

      this.setFlags();

      if (this.invoiceParams.isManual) {
        this.initCreateInvoiceManual(referentials);
      }

      this.eValuaRaisonSocialMandatory =
        !this.invoiceParams.isRejectedInvoice &&
        !this.invoiceParams.isInjection &&
        !this.invoiceParams.canManageInvoiceAGI &&
        !this.invoiceParams.isInvoiceForClient &&
        !this.invoiceParams.isManual;
    });

    this.afterGetInvoice();
  }

  afterGetInvoice() {
    this.invoiceParams.invoiceViewType = this.invoiceViewType;

    this.invoiceParams.isPrimaryReferenceRequired =
      this.invoiceViewType == InvoiceViewType.DISPATCHED ||
      this.invoiceViewType == InvoiceViewType.VOUCHERVALIDATED ||
      this.invoiceViewType == InvoiceViewType.CONTROL ||
      this.invoiceViewType == InvoiceViewType.WAITING;

    this.invoiceParams.canManageInvoiceAGI =
      this.invoiceDetailModel.CanManageInvoiceAGI;
    this.invoiceParams.isPrescriptorGroup =
      this.invoiceDetailModel.IsPrescriptorGroup;

    this.buildFormControls();

    this.invoiceParams.isInvoiceForClient =
      !_.isNil(this.invoiceDetailModel.ClientIdPPR) &&
      this.invoiceDetailModel.ClientIdPPR != '';

    this.invoiceParams.isInvoiceForGroup =
      !_.isNil(this.invoiceDetailModel.GroupIdPPR) &&
      this.invoiceDetailModel.GroupIdPPR != '';

    if (
      this.invoiceParams.isPendingForWorkflowCompletionVoucher ||
      this.invoiceParams.isPendingForVoucherValidation ||
      this.invoiceParams.isPendingForWorkflowCompletionPromotion
    ) {
      this.InvoiceService.getInvoiceTraceability(this.invoiceDetailModel.Id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((invoiceTraceability: InvoiceTraceabilityModel) => {
          this.invoiceTraceability = invoiceTraceability;
        });
    }

    if (
      (this.invoiceParams.isSearchDetail ||
        this.invoiceParams.isPendingForVoucherValidation) &&
      this.invoiceDetailModel.IsVoucher &&
      this.invoiceDetailModel.IsVoucherValidated != null
    ) {
      this.canUpdateVoucher =
        !this.invoiceDetailModel.IsVoucherValidated &&
        (this.authenticationInfoService.authentificatedUser.GroupsMembership.OperationalGroups.includes(
          this.invoiceDetailModel.CurrentAssignmentGroupId
        ) ||
          this.authenticationInfoService.authentificatedUser.GroupsMembership.NonERPComptabilityGroups.includes(
            this.invoiceDetailModel.Workflow.NonErpGroupId
          ));
    }

    this.initSubject();

    if (this.isPPRWorkingSituation || this.isPPRDirectInvoice) {
      this.setOperation(this.invoiceDetailModel.CurrentAssignmentGroupName);

      this.isCumulSituationChanged =
        this.isPPRWorkingSituation &&
        !_.isNull(this.invoiceDetailModel.CumulationPreviousSituationSetByUser);
    }

    if (!_.isNil(this.invoiceDetailModel.SupplierIdFournisseur)) {
      this.supplierId =
        this.invoiceDetailModel.SupplierIdFournisseur.toString();
      this.onFilterChangeSupplier(
        this.invoiceDetailModel.SupplierIdFournisseur + '|'
      );
    }

    this.setDropDownConfig();
  }

  ngAfterViewInit(): void {
    if (!this.invoiceParams.isManual) this.initPage();

    this.cdref.detectChanges();
  }

  initPage() {
    this.formGroupBuilder.markFormGroupTouched(this.invoiceDetailForm);
    this.subscribeInvoiceDetailFormChange();
    this.cdref.detectChanges();
  }

  ngAfterViewChecked() {}

  addFirstExpense() {
    const expense: InvoiceExpenseDetail = new InvoiceExpenseDetail();
    expense.CreatedAt = Date.now();
    expense.VatCode = '20';
    expense.AmountTaxExcluded = this.invoiceDetailModel.AmountTaxExcluded;

    this.invoiceDetailModel.Expenses.push(expense);
    this.InvoiceExpenses.push(this.addExpenseFormGroup(expense));
  }

  addExpenseFormGroup(expense: InvoiceExpenseDetail): UntypedFormGroup {
    const selectedvat = this.dropDownDataVat.find(
      (x) => x.Code == expense.VatCode
    );
    return this.formGroupBuilder.buildExpenseFormGroup(
      expense,
      this.invoiceParams,
      this.isReadOnlyFormOrWaiting,
      this.isReadOnlyForm,
      selectedvat
    );
  }

  initCreateInvoiceManual(referentials: ReferentialsModel) {
    const PrimaryReferenceId: number =
      this.route.snapshot.queryParams.PrimaryReferenceCreateId;

    this.assetService
      .getAssetById(PrimaryReferenceId)
      .subscribe((PrimaryReference) => {
        this.invoiceDetailModel.PrimaryReference = PrimaryReference.Reference;
        this.invoiceDetailModel.CurrentAssignmentGroupId =
          PrimaryReference.OperationalGroupId;
        this.invoiceDetailModel.CurrentAssignmentGroupName =
          PrimaryReference.OperationalGroupName;

        this.groupService
          .getGroupById(this.invoiceDetailModel.CurrentAssignmentGroupId)
          .subscribe((GroupAssignement) => {
            this.invoiceDetailModel.IsForPPRDirectInvoiceBDC =
              GroupAssignement.CanCreateInPPR;
            this.invoiceDetailModel.IsPrescriptorGroup =
              GroupAssignement.IsPrescriptorGroup;

            this.invoiceDetailModel.IsPPR = GroupAssignement.CanCreateInPPR;
            this.invoiceParams.canCreateInPPR = GroupAssignement.CanCreateInPPR;

            this.invoiceDetailModel.IsWorkingSituation = false;
            this.invoiceDetailModel.AmountTaxExcluded = null;
            this.invoiceDetailModel.AmountTaxIncluded = null;

            this.invoiceDetailModel.Expenses = [];
            this.invoiceDetailModel.Amendments = [];
            this.invoiceDetailModel.Deductions = [];
            this.invoiceDetailModel.Delegations = [];

            this.selectedAsset = [
              new ReferentialItem(0, this.invoiceDetailModel.PrimaryReference),
            ];

            this.setReferential(referentials);
            this.afterGetInvoice();
            this.initPage();
          });
      });
  }

  setReferential(referentials: ReferentialsModel) {
    if (!this.invoiceParams.isInjection && this.invoiceDetailModel.IsPPR) {
      this.dropDownDataVat = referentials.VatRefs;
      this.dropDownDataInvoicePPRType = referentials.InvoicePPRType;
      this.dropDownDataExpenseFamilyTypeAll = referentials.ExpenseFamilyTypes;
      this.dropDownDataDeductionType = referentials.DeductionType;
      this.dropDownDataDeductionTypeAll = referentials.DeductionType;
    }
  }

  initSubject() {
    // Subject search supplier in eValua
    this.supplierSearchEvent$
      .pipe(
        debounceTime(250),
        distinctUntilChanged(),
        tap((searchValue) => {
          if (!_.isNil(searchValue)) {
            this.supplierService
              .search(new SearchCriteria(searchValue, 20))
              .subscribe((data) => {
                _.forEach(data.Suppliers, (supplier) => {
                  return (supplier['CompanyNameAndSiret'] = `${
                    supplier.CompanyName
                  } (${supplier.Siret ?? 'Aucun SIRET'})`);
                });
                this.suppliers = data.Suppliers;

                if (!_.isNil(this.supplierId)) {
                  this.onChangeEvaluaCompany(
                    {
                      extMdmCode: Number.parseInt(this.supplierId),
                      CompanyNameAndSiret: null,
                    },
                    true
                  );
                  this.supplierId = null;
                }
              });
          }
        })
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();

    if (
      (this.isPPRDirectInvoice || this.isPPRWorkingSituation) &&
      !this.invoiceParams.isRejectedInvoice
    ) {
      // Subject search supplier in eValua pour "thirdParty"
      this.thirdPartySearchEvent$
        .pipe(
          debounceTime(250),
          distinctUntilChanged(),
          tap((searchValue) => {
            if (!_.isNil(searchValue)) {
              this.supplierService
                .search(new SearchCriteria(searchValue, 20))
                .subscribe((data) => {
                  _.forEach(data.Suppliers, (supplier) => {
                    return (supplier['CompanyNameAndSiret'] = `${
                      supplier.CompanyName
                    } (${supplier.Siret ?? 'Aucun SIRET'})`);
                  });
                  this.thirdParty = data.Suppliers;

                  if (!_.isNil(this.thirdPartyIdByTradeId)) {
                    this.onChangeThirdPartyPayer({
                      extMdmCode: Number.parseInt(this.thirdPartyIdByTradeId),
                      CompanyNameAndSiret: null,
                    });
                  }
                });
            }
          })
        )
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe();

      // Subject search operation in datawell
      this.operationSearchEvent$
        .pipe(
          debounceTime(250),
          distinctUntilChanged(),
          tap((searchValue) => {
            if (!_.isNil(searchValue)) {
              this.datawellService
                .searchOperationWithGlobalParam(
                  this.getParamFor_searchOperationWithGlobalParam(searchValue)
                )
                .subscribe((data) => {
                  this.dataOperations = data;
                  if (!_.isNil(this.invoiceDetailModel.OperationId)) {
                    this.onChangeOperation(
                      { id: this.invoiceDetailModel.OperationId },
                      true
                    );
                  }
                });
            }
          })
        )
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe();

      if (!_.isNil(this.invoiceDetailModel.OperationId)) {
        this.operationSearchEvent$.next(this.invoiceDetailModel.OperationId);
      }
    }

    if (this.isPPRWorkingSituation) {
      // Subject search supplier in eValua pour "Delegates"
      this.delegatesSearchEvent$
        .pipe(
          debounceTime(250),
          distinctUntilChanged(),
          tap((searchValue) => {
            if (!_.isNil(searchValue)) {
              this.supplierService
                .search(new SearchCriteria(searchValue, 20))
                .subscribe((data) => {
                  _.forEach(data.Suppliers, (supplier) => {
                    return (supplier['CompanyNameAndSiret'] = `${
                      supplier.CompanyName
                    } (${supplier.Siret ?? 'Aucun SIRET'})`);
                  });
                  this.delegates = data.Suppliers;
                });
            }
          })
        )
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe();

      // Subject search supplier in eValua pour "Creditors"
      this.creditorsSearchEvent$
        .pipe(
          debounceTime(250),
          distinctUntilChanged(),
          tap((searchValue) => {
            if (!_.isNil(searchValue)) {
              this.supplierService
                .search(new SearchCriteria(searchValue, 20))
                .subscribe((data) => {
                  _.forEach(data.Suppliers, (supplier) => {
                    return (supplier['CompanyNameAndSiret'] = `${
                      supplier.CompanyName
                    } (${supplier.Siret ?? 'Aucun SIRET'})`);
                  });
                  this.creditors = data.Suppliers;
                });
            }
          })
        )
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe();
    }
  }

  setDropDownConfig() {
    this.dropDownSettingsAssets = this.multiSelectModel.getSettings(
      'Label',
      'Label',
      true,
      true
    );
    this.dropDownSettingsAssets.allowRemoteDataSearch = true;

    this.dropDownSettingsRecipientEntities = this.multiSelectModel.getSettings(
      'Id',
      'Label',
      true,
      true
    );
    this.dropDownSettingsRecipientEntities.allowRemoteDataSearch = true;

    this.dropDownSettingsSuppliers = this.multiSelectModel.getSettings(
      'extMdmCode',
      'CompanyNameAndSiret',
      true,
      true,
      true,
      false,
      'Chercher un fournisseur',
      null,
      true
    );
    this.dropDownSettingsThirdParty = this.multiSelectModel.getSettings(
      'extMdmCode',
      'CompanyNameAndSiret',
      true,
      true,
      true,
      false,
      'Chercher un fournisseur',
      null,
      true
    );
    this.dropDownSettingsDelegates = this.multiSelectModel.getSettings(
      'extMdmCode',
      'CompanyNameAndSiret',
      true,
      true,
      true,
      false,
      'Chercher un délégataire',
      null,
      true
    );
    this.dropDownSettingsCreditors = this.multiSelectModel.getSettings(
      'extMdmCode',
      'CompanyNameAndSiret',
      true,
      true,
      true,
      false,
      'Chercher un créancier',
      null,
      true
    );

    this.dropDownSettingsVat = this.multiSelectModel.getSettings(
      'Code',
      'Label',
      true,
      true
    );
    this.dropDownSettingsVat.allowRemoteDataSearch = true;

    this.dropDownSettingsExpenseFamilyType = this.multiSelectModel.getSettings(
      'FamilyCode',
      'FamilyLabelWithcode',
      true,
      true
    );
    this.dropDownSettingsExpenseFamilyType.allowRemoteDataSearch = true;

    this.dropDownSettingsInvoicePPRType = this.multiSelectModel.getSettings(
      'Code',
      'Label',
      true,
      false
    );

    this.dropDownSettingsDeductionType = this.multiSelectModel.getSettings(
      'Code',
      'Label',
      true,
      false
    );

    this.dropDownSettingsAvenant = this.multiSelectModel.getSettings(
      'numeroAvenant',
      'label',
      true,
      false
    );

    this.dropDownSettingsOperations = this.multiSelectModel.getSettings(
      'id',
      'id',
      true,
      true,
      true,
      false,
      'Chercher une opération',
      null,
      true
    );
    this.dropDownSettingsCommandes = this.multiSelectModel.getSettings(
      'id',
      'numeroInterneWithLabel',
      true,
      true
    );
    this.dropDownSettingsMarches = this.multiSelectModel.getSettings(
      'idMarche',
      'label',
      true,
      true,
      true,
      false,
      'Chercher un corp de métier',
      null,
      true
    );
  }

  //#region Recherche sur le DataWell après le choix de l'opération
  setOperation(CurrentAssignmentGroupName: string) {
    if (
      _.isNil(this.invoiceDetailModel.OperationId) &&
      !_.isNil(CurrentAssignmentGroupName)
    ) {
      let selectedOperation = CurrentAssignmentGroupName.split('-')[1];

      if (!_.isNil(selectedOperation)) {
        selectedOperation = selectedOperation.substring(0, 5);
        this.datawellService
          .getOperationById(selectedOperation)
          .subscribe((data) => {
            if (data != null) {
              this.onFilterChangeOperation(selectedOperation);
              this.dataOperations.push(data);
              this.onChangeOperation({ id: selectedOperation });
            } else {
              this.onChangeOperation({ id: null });
            }
          });
      }
    }
  }

  setCommandes(idOperation: string, resetExpenses: boolean = true) {
    const clientId = this.invoiceDetailModel.ClientIdPPR?.toString();
    const groupId = this.invoiceDetailModel.GroupIdPPR?.toString();
    const supplierId = this.invoiceDetailModel.SupplierIdFournisseur?.toString();
    
    const tierId = !_.isNil(clientId) ? clientId : (!_.isNil(groupId) ? groupId : supplierId);

    if (!_.isNil(idOperation) && !_.isNil(tierId)) {
      // Recherche idFournisseur PPR via id Fournisseur eValua et filtre des commandes associé idOperation / fournisseur
      this.datawellService
        .searchTierWithGlobalParam(
          new SearchGlobalParam(null, ['idTiers'], null, [
            new SearchParam('idCompta', SearchParamOperator.EQUALS, [
              tierId,
            ]),
          ])
        )
        .subscribe((tier) => {
          if (tier != undefined && tier.length > 0) {
            const fournisseur: string = tier[0].idTiers;
            this.datawellService
              .searchCommandeWithGlobalParam(
                this.getParamFor_searchCommandeWithGlobalParam(
                  idOperation,
                  fournisseur
                )
              )
              .subscribe((data) => {
                if (data != undefined && data.length > 0) {
                  data.reduce(this.collectCommandeConcatRowColums, []);
                  this.dataCommandes = data;
                }

                this.setExpenseFamilyDropDownFilter(resetExpenses);

                if (!_.isNil(this.invoiceDetailModel.CommandeInternalNumber))
                  this.onChangeCommande(
                    {
                      id: this.invoiceDetailModel.CommandeId,
                      numeroInterneWithLabel: '',
                    },
                    true
                  );
              });
          } else {
            this.setExpenseFamilyDropDownFilter(resetExpenses);
          }
        });
    } else {
      this.dataCommandes = [];
      this.onChangeCommande(null);
      this.setExpenseFamilyDropDownFilter(resetExpenses);
    }
  }

  setMarches(idOperation: string) {
    const clientId = this.invoiceDetailModel.ClientIdPPR?.toString();
    const groupId = this.invoiceDetailModel.GroupIdPPR?.toString();
    const supplierId = this.invoiceDetailModel.SupplierIdFournisseur?.toString();
    
    const tierId = !_.isNil(clientId) ? clientId : (!_.isNil(groupId) ? groupId : supplierId);

    if (!_.isNil(idOperation) && !_.isNil(tierId)) {
      this.datawellService
        .searchTierWithGlobalParam(
          new SearchGlobalParam(null, ['idTiers'], null, [
            new SearchParam('idCompta', SearchParamOperator.EQUALS, [
              tierId,
            ]),
          ])
        )
        .subscribe((tier) => {
          if (tier != undefined && tier.length > 0) {
            const fournisseur: string = tier[0].idTiers;
            this.datawellService
              .searchMarcheWithGlobalParam(
                this.getParamFor_searchMarcheWithGlobalParam(
                  idOperation,
                  fournisseur
                )
              )
              .subscribe((data) => {
                if (data != undefined && data.length > 0) {
                  data.reduce(this.collectMarcheConcatRowColumns, []);
                  this.dataMarches = data;
                  if (!_.isNil(this.invoiceDetailModel.MarketId)) {
                    const data = _.find(
                      this.dataMarches,
                      (x) => x?.idMarche === this.invoiceDetailModel.MarketId
                    );
                    this.setMarcheLabel(this.invoiceDetailModel.MarketId);
                    this.setMontantMarche(data);
                    this.setAvenant(idOperation, data?.idMarche, true);
                    this.childDeduction.setPercentage(
                      data,
                      true,
                      this.invoiceDetailAmountCalc
                        .marketAndAmendmentsTaxIncluded
                    );
                    this.setSituationDelegation();
                  }
                } else {
                  this.dataMarches = [];
                }
              });
          }
        });
    } else {
      this.dataMarches = [];
    }
  }

  setThirdParty(creantier: string) {
    if (!_.isNil(creantier) && creantier != '') {
      this.datawellService.getTierById(creantier).subscribe((data) => {
        this.thirdPartyIdByTradeId = data.idCompta;
        this.onFilterChangeThirdParty(data.idCompta + '|');
        this.onChangeThirdPartyPayer({
          extMdmCode: Number(this.thirdPartyIdByTradeId),
          CompanyNameAndSiret: null,
        });
      });
    } else {
      this.thirdPartyIdByTradeId = null;
      this.onChangeThirdPartyPayer({
        extMdmCode: 0,
        CompanyNameAndSiret: null,
      });
    }
  }

  setCumulativSituationAmount(marketId: string) {
    if (!_.isNil(marketId) && marketId != '') {
      const originalAmount =
        this.pristineFormValue.CumulationPreviousSituationAmountTaxExcluded;

      const supplierChanged = this.eValuaSIRETValueOnStartup != this.invoiceDetailModel.SupplierEvaluaSIRET;

      if (_.isNil(originalAmount) || originalAmount == '' || supplierChanged) {
        this.InvoiceService.getCumulativePreviousSituationAmount(
          marketId
        ).subscribe((amount) => {
          this.invoiceDetailModel.CumulationPreviousSituationAmountTaxExcluded =
            amount;
          this.invoiceDetailForm.controls.CumulationPreviousSituationAmountTaxExcluded.patchValue(
            this.decimalPipe.transform(amount, '1.2-2')
          );
        });
      }
      this.setWorkCumulAmount(marketId);
    }
  }

  setWorkCumulAmount(marketId: string) {
    if (!_.isNil(marketId) && marketId != '') {
      this.InvoiceService.getWorkCumulAmount(marketId).subscribe((amount) => {
        this.invoiceDetailModel.WorkSituationAmountTaxExcluded = amount;
      });
    }
  }

  onChangeIssuedAt() {
    if (this.isPPRDirectInvoice || this.isPPRWorkingSituation) {
      let dateFacture = moment(this.invoiceDetailForm.controls.IssuedAt.value);
      const isDateValid = dateFacture.isValid();

      if (isDateValid) {
        let idDelai;
        let idCondition;

        if (this.invoiceDetailModel.IsForPPRDirectInvoiceBDC) {
          const data = _.find(
            this.dataCommandes,
            (x) => x?.id == this.invoiceDetailModel.CommandeId
          );
          idDelai = data?.idDelai;
          idCondition = data?.idCondition;
        } else {
          const data = _.find(
            this.dataMarches,
            (x) => x?.idMarche === this.invoiceDetailModel.MarketId
          );
          idDelai = data?.idDelai;
          idCondition = data?.idCondition;
        }

        this.setDueDate(
          this.invoiceDetailForm.controls.IssuedAt.value,
          idDelai,
          idCondition
        );
      }
    }
  }

  setDueDate(dateFacture: string, idDelai: string, idCondition: string) {
    // Calcul d'échéance
    if (!_.isNil(idDelai) && !_.isNil(idCondition)) {
      const dueDate = this.commonLibrary.calculatedDueDate(
        dateFacture,
        idDelai,
        idCondition
      );
      this.invoiceDetailModel.DueDate = dueDate;
      this.invoiceDetailForm.controls.DueDate.patchValue(
        moment(this.invoiceDetailModel.DueDate).format('YYYY-MM-DD')
      );
    }
  }

  setAvenant(
    idOperation: string,
    idMarche: string,
    isLoading: boolean = false
  ) {
    if (
      !_.isNil(idOperation) &&
      idOperation != '' &&
      !_.isNil(idMarche) &&
      idMarche != ''
    ) {
      this.datawellService
        .searchAvenantWithGlobalParam(
          this.getParamFor_searchAvenantWithGlobalParam(idOperation, idMarche)
        )
        .subscribe((data) => {
          data.reduce(this.collectAvenantConcatRowColumns, []);
          this.dropDownDataAvenant = data;

          if (this.dropDownDataAvenant.length > 0) {
            this.datawellService
              .searchAvancementAvenantsWithGlobalParam(
                this.getParamFor_searchAvancementAvenantWithGlobalParam()
              )
              .subscribe((data) => {
                this.dropDownDataAvenant.forEach((current) => {
                  const findData = _.find(
                    data,
                    (x) => x?.idAvenant === current.idAvenant
                  );
                  current.avancementCumulHT =
                    current.montantHT - (findData?.cumulHT ?? 0);
                });

                if (!this.isReadOnlyForm) {
                  const filteredArray = this.dropDownDataAvenant.filter(
                    (d) => d.avancementCumulHT != 0
                  );
                  this.dropDownDataAvenant = filteredArray;
                }

                if (isLoading) {
                  this.childAmendment.setReadOnlyInformations(
                    this.dropDownDataAvenant
                  );
                  this.setWorkCumulAmount(idMarche);
                } else {
                  this.childAmendment.resetAmendments();
                }
              });
          }
        });
    }
  }

  setSituationDelegation() {
    this.selectedDelegations = [];
    if (this.isPPRWorkingSituation) {
      // Call delegations by MarketId to get all "delegataire" & "creantier"
      this.datawellService
        .getDelegationsById(this.invoiceDetailModel.MarketId)
        .subscribe((data) => {
          if (data.data != undefined) {
            data.data.forEach((element) => {
              this.selectedDelegations.push(
                new DelegationOverride(element.delegataire, element.forfaitTTC)
              );
            });

            const allDelegates = [
              ...data.data
                .map((c) => c.delegataire)
                .filter((value, index, self) => self.indexOf(value) === index),
            ];
            const allCreditors = [
              ...data.data
                .map((c) => c.creancier)
                .filter((value, index, self) => self.indexOf(value) === index),
            ];

            if (allDelegates.length > 0) {
              this.datawellService
              .searchTierWithGlobalParam(
                this.getParamFor_searchTierWithGlobalParam(allDelegates)
              )
              .subscribe((tier) => {
                if (tier != undefined) {
                  tier.forEach((t) => {
                    const index = this.selectedDelegations.findIndex(
                      (x) => x.delegataire === t.idTiers
                    );
                    this.selectedDelegations[index].evaluaId = toNumber(
                      t.idCompta
                    );
                  });

                  let allDelegateseValua = [
                    ...tier
                      .map((c) => c.idCompta)
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      ),
                  ].join('|');
                  allDelegateseValua =
                    allDelegateseValua.indexOf('|') == -1
                      ? allDelegateseValua.concat('|')
                      : allDelegateseValua;
                  this.onFilterChangeDelegates(allDelegateseValua);
                }
              });
            }

            if (allCreditors.length > 0) {
              this.datawellService
              .searchTierWithGlobalParam(
                this.getParamFor_searchTierWithGlobalParam(allCreditors)
              )
              .subscribe((tier) => {
                if (tier != undefined) {
                  let allCreditorseValua = [
                    ...tier
                      .map((c) => c.idCompta)
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      ),
                  ].join('|');
                  allCreditorseValua =
                    allCreditorseValua.indexOf('|') == -1
                      ? allCreditorseValua.concat('|')
                      : allCreditorseValua;
                  this.onFilterChangeCreditors(allCreditorseValua);
                }
              });
            }
          }
        });
    }
  }

  setExpenseFamilyDropDownFilter(resetExpenses: boolean = true) {
    const isExpensesOrRevenueSet: boolean = !_.isNil(
      this.invoiceDetailModel.InvoicePPRType
    );
    const isForClientSet: boolean =
      !_.isNil(this.invoiceDetailModel.ClientIdPPR) &&
      !_.isEmpty(this.invoiceDetailModel.ClientIdPPR);

    let isRevenue: boolean = false;
    if (isExpensesOrRevenueSet) {
      isRevenue =
        this.invoiceDetailModel.InvoicePPRType == InvoicePPRTypeEnum.RECETTE;
    }

    if (!_.isNil(this.invoiceDetailModel.CommandeId)) {
      const data = _.find(
        this.dataCommandes,
        (x) => x?.id === this.invoiceDetailModel.CommandeId
      );

      let arrayExpenseForTrade: Array<string> = new Array<string>();
      if (data != null && data != undefined) {
        data.lignes.forEach((data) => {
          arrayExpenseForTrade.push(data.famille.idFamille);
        });
      }

      this.dropDownDataExpenseFamilyType = [
        ...this.dropDownDataExpenseFamilyTypeAll.filter((c) =>
          arrayExpenseForTrade.includes(c.FamilyCode)
        ),
      ];
    } else {
      const filterwithRef1: boolean =
        [
          ...this.dropDownDataExpenseFamilyTypeAll.filter(
            (c) =>
              !_.isNil(c.FamilyFilterByRef1) &&
              c.FamilyFilterByRef1.split(';').includes(
                this.invoiceDetailModel.PrimaryReference
              )
          ),
        ].length > 0;

      if (isExpensesOrRevenueSet && !filterwithRef1) {
        this.dropDownDataExpenseFamilyType = [
          ...this.dropDownDataExpenseFamilyTypeAll.filter(
            (c) =>
              (isExpensesOrRevenueSet
                ? c.FamilyIsRevenue === isRevenue
                : true) &&
              (isForClientSet
                ? c.FamilyIsInvoiceForClient === isForClientSet
                : c.FamilyIsInvoiceForSupplier === true)
          ),
        ];
      } else {
        this.dropDownDataExpenseFamilyType = [
          ...this.dropDownDataExpenseFamilyTypeAll.filter(
            (c) =>
              (!filterwithRef1
                ? c.FamilyWithoutBDC
                : !_.isNil(c.FamilyFilterByRef1) &&
                  c.FamilyFilterByRef1.split(';').includes(
                    this.invoiceDetailModel.PrimaryReference
                  )) &&
              (isForClientSet
                ? c.FamilyIsInvoiceForClient === isForClientSet
                : c.FamilyIsInvoiceForSupplier === true)
          ),
        ];
      }
    }
  }
  //#endregion

  //#region  onChange

  onFilterChangeSupplier(data: any) {
    this.supplierSearchEvent$.next(data);
  }

  onFilterChangeThirdParty(data: any) {
    this.thirdPartySearchEvent$.next(data);
  }

  onFilterChangeDelegates(data: any) {
    this.delegatesSearchEvent$.next(data);
  }

  onFilterChangeCreditors(data: any) {
    this.creditorsSearchEvent$.next(data);
  }

  onFilterChangeOperation(data: any) {
    this.operationSearchEvent$.next(data);
  }

  onChangeCheckBDC(event: MatCheckboxChange): void {
    this.ngxService.start();
    this.onChangeCheck(event.checked);
    this.ngxService.stop();
  }

  onChangeCheckSituation(event: MatCheckboxChange): void {
    this.ngxService.start();
    this.invoiceDetailForm.controls.AmountTaxExcluded.setValue(
      this.decimalPipe.transform(
        this.invoiceDetailModel.AmountTaxExcluded,
        '1.2-2'
      )
    );
    this.invoiceDetailForm.controls.AmountTaxIncluded.setValue(
      this.decimalPipe.transform(
        this.invoiceDetailModel.AmountTaxIncluded,
        '1.2-2'
      )
    );

    this.onChangeCheck(!event.checked);
    this.initSubject();
    this.ngxService.stop();
  }

  onChangeEvaluaCompany(
    selectedSupplier?: {
      extMdmCode: number;
      CompanyNameAndSiret: string;
    } | null,
    isLoading: boolean = false
  ): void {
    this.editedDropdowns.push('SupplierEvaluaCompanyName');

    const supplierDatas = _.find(
      this.suppliers,
      (x) => x?.extMdmCode === selectedSupplier?.extMdmCode
    );

    if (this.isPPRDirectInvoice || this.isPPRWorkingSituation) {
      const hasValidSupplierCode = !_.isNil(selectedSupplier?.extMdmCode.toString());
    
      if (!_.isNil(this.invoiceDetailModel.ClientIdPPR) && hasValidSupplierCode && this.isPPRDirectInvoice) {
        this.setValidatorSupplierOrClient(false);
      }
    
      if (!_.isNil(this.invoiceDetailModel.GroupIdPPR) && hasValidSupplierCode) {
        this.setValidatorSupplierOrClient(false, false);
      }
    }

    this.invoiceDetailModel.SupplierIdFournisseur = supplierDatas?.extMdmCode;
    this.invoiceDetailModel.SupplierMdmId = supplierDatas?.extMdmCode;
    this.invoiceDetailModel.SupplierSageErpCode =
      supplierDatas?.functionnalERPCode;
    this.invoiceDetailModel.SupplierEvaluaCompanyName =
      supplierDatas?.CompanyName;
    this.invoiceDetailModel.SupplierEvaluaSIRET = supplierDatas?.Siret;

    if (!isLoading) {
      this.invoiceDetailForm.controls.SupplierEvaluaCompanyName.patchValue(
        supplierDatas?.CompanyName ? [supplierDatas?.CompanyName] : []
      );

      if (this.isPPRDirectInvoice) {
        this.onChangeCommande(
          _.isNil(selectedSupplier?.extMdmCode)
            ? null
            : {
                id: selectedSupplier?.extMdmCode.toString(),
                numeroInterneWithLabel: '',
              },
          false
        );
        this.onChangeOperation({ id: this.invoiceDetailModel.OperationId });
      } else if (this.isPPRWorkingSituation) {
        this.setMarches(this.invoiceDetailModel.OperationId);
        this.onChangeMarche({ idMarche: null });
      }
    }
  }

  onChangeInvoicePPRType(selectedInvoiceType?: { Code: string } | null): void {
    this.editedDropdowns.push('InvoicePPRType');
    const datas = _.find(
      this.dropDownDataInvoicePPRType,
      (x) => x?.Code === selectedInvoiceType?.Code
    );

    this.invoiceDetailModel.InvoicePPRType = datas?.Code;

    this.invoiceDetailForm.controls.InvoicePPRType.patchValue(datas?.Code);
    this.invoiceDetailForm.controls.InvoicePPRTypeLabel.patchValue([datas]);

    this.setExpenseFamilyDropDownFilter();
  }

  onChangeThirdPartyPayer(
    selectedSupplier?: {
      extMdmCode: number;
      CompanyNameAndSiret: string;
    } | null
  ): void {
    this.editedDropdowns.push('ThirdPartyPayerName');
    const supplierDatas = _.find(
      this.thirdParty,
      (x) => x?.extMdmCode === selectedSupplier?.extMdmCode
    );

    this.invoiceDetailModel.ThirdPartyPayerId = supplierDatas?.extMdmCode;
    this.invoiceDetailModel.ThirdPartyPayerName = supplierDatas?.CompanyName;

    this.invoiceDetailForm.controls.ThirdPartyPayerId.patchValue(
      supplierDatas?.extMdmCode
    );
    this.invoiceDetailForm.controls.ThirdPartyPayerName.patchValue(
      supplierDatas?.CompanyName ? [supplierDatas?.CompanyName] : []
    );
  }

  onChangeOperation(
    selectedOperation?: { id: string } | null,
    loading: boolean = false
  ): void {
    this.editedDropdowns.push('OperationId');
    const data = _.find(
      this.dataOperations,
      (x) => x?.id === selectedOperation?.id
    );

    const opeSocName = data?.nomEntiteJuridique
      ? data?.nomFormeJuridique.concat(' ', data?.nomEntiteJuridique)
      : '';

    this.invoiceDetailModel.OperationId = data?.id;
    this.invoiceDetailModel.OperationName = data?.nom;
    this.invoiceDetailModel.OperationSocieteId = data?.idSociete;
    this.invoiceDetailModel.OperationSocieteName = opeSocName;
    this.invoiceDetailModel.OperationEntiteComptable = data?.idEntiteComptable;

    this.setOperationAssistantName(selectedOperation, loading);

    if (!loading) {
      this.invoiceDetailForm.controls.OperationId.patchValue(
        data?.id ? [data?.id] : []
      );
    }

    this.invoiceDetailForm.controls.OperationName.patchValue(data?.nom);
    this.invoiceDetailForm.controls.OperationSocieteId.patchValue(
      data?.idSociete
    );
    this.invoiceDetailForm.controls.OperationSocieteName.patchValue(opeSocName);
    this.invoiceDetailForm.controls.OperationEntiteComptable.patchValue(
      data?.idEntiteComptable
    );

    if (this.invoiceDetailModel.IsForPPRDirectInvoiceBDC) {
      this.setCommandes(data?.id, !loading);
      if (_.isNil(data?.id)) {
        this.onChangeCommande({ id: null, numeroInterneWithLabel: '' });
      }
    }

    if (this.invoiceDetailModel.IsWorkingSituation) {
      this.setMarches(data?.id);
      if (_.isNil(data?.id)) {
        this.onChangeMarche({ idMarche: null });
      }
    }
  }

  setOperationAssistantName(
    selectedOperation?: { id: string } | null,
    loading: boolean = false
  ) {
    if (selectedOperation && !_.isNil(selectedOperation.id) && !loading) {
      this.datawellService
        .getIntervenantsById(selectedOperation.id)
        .subscribe((result) => {
          if (result.data != undefined) {
            const data = _.find(
              result.data,
              (x) => x?.idFonction === IntervenantFunction.ASSISTANTE_OPERATION
            );
            this.invoiceDetailModel.OperationAssistantName = data?.nom;
          }
        });
    } else {
      this.invoiceDetailModel.OperationAssistantName = '';
    }
  }

  onChangeCommande(
    selectedCommande?: { id: string; numeroInterneWithLabel: string } | null,
    isLoading: boolean = false
  ): void {
    this.editedDropdowns.push('CommandeInternalNumber');

    let data = _.find(this.dataCommandes, (x) => x?.id == selectedCommande?.id);

    if (selectedCommande != null) {
      this.invoiceDetailForm.controls.SelectedCommandeInternalNumber.patchValue([
        data,
      ]);
      }
    else {
      this.invoiceDetailForm.controls['SelectedCommandeInternalNumber'].setValue(null);
    }

    if (!isLoading) {
      this.invoiceDetailModel.CommandeId = data?.id;
      this.invoiceDetailModel.CommandeInternalNumber = data?.numeroInterne;

      this.invoiceDetailForm.controls.CommandeId.patchValue(data?.id);
      this.invoiceDetailForm.controls.CommandeInternalNumber.patchValue(
        data?.numeroInterne
      );

      this.setDueDate(
        this.invoiceDetailForm.controls.IssuedAt.value,
        data?.idDelai,
        data?.idCondition
      );

      this.setThirdParty(data?.creancier);
      if (this.isPPRDirectInvoice) {
        this.childExpense.deleteAllExpense();
        this.childExpense.addFirstExpense();
        this.setExpenseFamilyDropDownFilter();
      }
    }

    this.invoiceDetailInformationBDC.libelle = data?.lignes[0].libelle;
    this.invoiceDetailInformationBDC.montantHT = this.decimalPipe.transform(
      data?.montantHT,
      '1.2-2'
    );
  }

  setMarcheLabel(idMarche: string) {
    const data = _.find(this.dataMarches, (x) => x?.idMarche === idMarche);
    this.invoiceDetailForm.controls.SelectedTrade.patchValue(
      data?.idMarche ? [data] : []
    );
  }

  onChangeMarche(selectedMarche?: { idMarche: string } | null): void {
    const data = _.find(
      this.dataMarches,
      (x) => x?.idMarche === selectedMarche?.idMarche
    );
    this.selectedMarche = data;

    this.invoiceDetailModel.MarketId = data?.idMarche;
    this.invoiceDetailModel.TradeId = data?.idCorpsMetier;
    this.invoiceDetailModel.TradeLabel = data?.libelleCorpsMetier;

    this.invoiceDetailForm.controls.MarketId.patchValue(data?.idMarche);
    this.invoiceDetailForm.controls.TradeId.patchValue(data?.idCorpsMetier);
    this.invoiceDetailForm.controls.TradeLabel.patchValue(
      data?.libelleCorpsMetier ? [data?.libelleCorpsMetier] : []
    );
    this.invoiceDetailForm.controls.SelectedTrade.patchValue(
      data?.idMarche ? [data] : []
    );

    this.setMontantMarche(data);

    this.setDueDate(
      this.invoiceDetailForm.controls.IssuedAt.value,
      data?.idDelai,
      data?.idCondition
    );

    this.setThirdParty(data?.idCession);
    this.setCumulativSituationAmount(data?.idMarche);

    this.setAvenant(this.invoiceDetailModel.OperationId, data?.idMarche);

    if (data != null) {
      this.childDeduction.setPercentage(
        data,
        false,
        this.invoiceDetailAmountCalc.marketAndAmendmentsTaxIncluded
      );
    }
    this.setSituationDelegation();
  }

  setMontantMarche(data: Marche) {
    this.invoiceDetailModel.AmountTradeExcludingTax = data?.montantHT;
    this.invoiceDetailForm.controls.AmountTradeExcludingTax.patchValue(
      this.decimalPipe.transform(data?.montantHT, '1.2-2')
    );
  }

  onAssetFilterChange = (data: string) => {
    super.onAssetFilterChange(data);
  };

  protected onAssetFetched(assets: ReferentialItem[]) {
    this.dropDownDataAssets = assets;
  }

  protected onRecipientEntitiesFetched(recipientEntities: ReferentialItem[]) {
    this.dropDownDataRecipientEntities = recipientEntities;
  }
  //#endregion

  get hasFiles(): boolean {
    return !_.isNil(this.uploadComponent) && this.uploadComponent.hasFiles;
  }

  setFlags(): void {
    if (_.isNil(this.invoiceViewType)) {
      this.invoiceViewType =
        this.route.snapshot.paramMap.get('invoiceViewType');
    }

    this.invoiceParams.isDispatchedInvoice =
      this.invoiceViewType == InvoiceViewType.DISPATCHED;
    this.invoiceParams.isSearchDetail =
      this.invoiceViewType == InvoiceViewType.SEARCH;
    this.invoiceParams.isRejectedInvoice =
      this.invoiceViewType == InvoiceViewType.REJECTED;
    this.invoiceParams.isPendingForWorkflowCompletionVoucher =
      this.invoiceViewType == InvoiceViewType.VOUCHERWORKFLOW;
    this.invoiceParams.isPendingForWorkflowCompletionPromotion =
      this.invoiceViewType == InvoiceViewType.PROMOTIONWORKFLOW;
    this.invoiceParams.isPendingForVoucherValidation =
      this.invoiceViewType == InvoiceViewType.VOUCHERVALIDATED;
    this.invoiceParams.isControl =
      this.invoiceViewType == InvoiceViewType.CONTROL;
    this.invoiceParams.isWaiting =
      this.invoiceViewType === InvoiceViewType.WAITING;
    this.invoiceParams.isManual =
      this.invoiceViewType === InvoiceViewType.MANUAL;
    this.invoiceParams.isComplaintInvoice = this.invoiceDetailModel.IsComplaint;

    this.isReturnOperationalComment =
      this.invoiceDetailModel.IsComplaint &&
      this.invoiceDetailModel.IsReturnOperationalComment;
  }

  isOther(asset: ReferentialItem): boolean {
    return asset.Label === ' Nouveau';
  }

  //#region FormChange action
  subscribeInvoiceDetailFormChange = (): void => {
    this.setPristine();

    this.isFormUpdated = false;
    this.invoiceDetailForm.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.updateChanges();
      });
  };

  setPristine() {
    this.pristineFormValue = this.invoiceDetailForm.value;
    this.pristineFormValue.selectedRecipientEntityId =
      this.selectedRecipientEntityId;
    this.pristineFormValue.selectedAssetReference = this.selectedAssetReference;
    delete this.pristineFormValue.PrimaryReference;
    delete this.pristineFormValue.RecipientEntity;
  }

  onRecipientEntityChange = (): void => {
    if (_.isNil(this.pristineFormValue)) {
      return;
    }
    this.editedDropdowns.push('RecipientEntity');

    this.updateChanges();
  };

  onAssetValueChange = (): void => {
    if (_.isNil(this.pristineFormValue)) {
      return;
    }

    this.updateChanges();
  };

  onChangePrimaryReference(selectedRef1?: { Label: string } | null): void {
    this.invoiceDetailModel.PrimaryReference = selectedRef1?.Label;
    if (this.isPPRDirectInvoice) this.setExpenseFamilyDropDownFilter();
  }

  updateChanges = (): void => {
    this.isFormUpdated = this.isReadOnlyForm ? false : this.hasFormChanged;
    this.invoiceFormFile = !_.isNil(this.uploadComponent)
      ? _.head(this.uploadComponent.Files)
      : null;
  };

  private get hasFormChanged(): boolean {
    if (_.isNil(this.pristineFormValue)) {
      return true;
    }
    const excludedZone: string[] = [
      'PrimaryReference',
      'RecipientEntity',
      'OperationSocieteName',
      'OperationEntiteComptable',
      'SelectedCommandeInternalNumber',
      'SelectedTrade',
      'TradeLabel',
    ];
    const arrayZone: string[] = [
      'InvoiceExpenses',
      'InvoiceAmendments',
      'InvoiceDeductions',
      'InvoiceDelegations',
    ];

    let keys = Object.keys(this.invoiceDetailForm.value).filter(
      (k) => !excludedZone.includes(k) && !arrayZone.includes(k)
    );
    if (this.hasFormChangedLoopString(keys, this.pristineFormValue)) {
      return true;
    }

    if (this.isPPRDirectInvoice) {
      // Expenses
      if (this.hasFormChangedLoopExpenses()) {
        return true;
      }
    }

    if (this.isPPRWorkingSituation) {
      // Amendments
      if (this.hasFormChangedLoopAmendments()) {
        return true;
      }

      // Deductions
      if (this.hasFormChangedLoopDeductions()) {
        return true;
      }

      // Delegations
      if (this.hasFormChangedLoopDelegations()) {
        return true;
      }
    }
    return (
      this.pristineFormValue.selectedRecipientEntityId !==
        this.selectedRecipientEntityId ||
      this.pristineFormValue.selectedAssetReference !==
        this.selectedAssetReference
    );
  }

  hasFormChangedLoopString(keys: string[], pristineControl: any[]): boolean {
    for (const key of keys) {
      if (
        this.invoiceDetailForm.value[key] === '' &&
        _.isNil(pristineControl[key])
      ) {
        continue;
      }
      if (this.invoiceDetailForm.value[key] != pristineControl[key]) {
        return true;
      }
    }
    return false;
  }

  hasFormChangedLoopExpenses(): boolean {
    let internalkeys: any[] =
      this.invoiceDetailForm.controls.InvoiceExpenses.value;
    let internalPristine: any[] = this.pristineFormValue['InvoiceExpenses'];

    if (internalkeys.length != internalPristine.length) {
      return true;
    }

    if (internalkeys && internalPristine) {
      const result = this.hasFormChangedLoopObject(
        internalkeys,
        internalPristine
      );
      return result;
    } else return false;
  }

  hasFormChangedLoopAmendments(): boolean {
    let internalkeys: any[] =
      this.invoiceDetailForm.controls.InvoiceAmendments.value;
    let internalPristine: any[] = this.pristineFormValue['InvoiceAmendments'];

    if (internalkeys.length != internalPristine.length) {
      return true;
    }

    if (internalkeys && internalPristine) {
      const result = this.hasFormChangedLoopObject(
        internalkeys,
        internalPristine
      );
      return result;
    } else return false;
  }

  hasFormChangedLoopDeductions(): boolean {
    let internalkeys: any[] =
      this.invoiceDetailForm.controls.InvoiceDeductions.value;
    let internalPristine: any[] = this.pristineFormValue['InvoiceDeductions'];

    if (internalkeys.length != internalPristine.length) {
      return true;
    }

    if (internalkeys && internalPristine)
      return this.hasFormChangedLoopObject(internalkeys, internalPristine);
    else return false;
  }

  hasFormChangedLoopDelegations(): boolean {
    let internalkeys: any[] =
      this.invoiceDetailForm.controls.InvoiceDelegations.value;
    let internalPristine: any[] = this.pristineFormValue['InvoiceDelegations'];

    if (internalkeys.length != internalPristine.length) {
      return true;
    }

    if (internalkeys && internalPristine)
      return this.hasFormChangedLoopObject(internalkeys, internalPristine);
    else return false;
  }

  hasFormChangedLoopObject(
    internalkeys: any[],
    internalPristine: any[]
  ): boolean {
    var resultUpdated = false;

    internalkeys.some((element) => {
      const key: string = JSON.stringify(element);
      const pristine: string = JSON.stringify(
        internalPristine.find((x) => x.CreatedAt == element.CreatedAt)
      );

      resultUpdated = resultUpdated ? resultUpdated : key !== pristine;
    });

    return resultUpdated;
  }
  //#endregion

  get primaryReferenceHasChanged(): boolean {
    if (_.isNil(this.pristineFormValue)) {
      return false;
    }

    return !this.hasNotChanged(
      this.pristineFormValue.selectedAssetReference,
      this.selectedAssetReference
    );
  }

  get showLastForwardComment(): boolean {
    return (
      this.authenticationInfoService.authentificatedUser.hasGrant(
        AccessRequirement.SupervisionMembership
      ) && this.invoiceViewType === InvoiceViewType.REJECTED
    );
  }

  get hasMandatoryFieldChanged(): boolean {
    if (this.isReadOnlyForm) {
      return false;
    }

    if (_.isNil(this.pristineFormValue)) {
      return false;
    }

    if (!this.isReadOnlyForm == false && this.hasFormChanged == false) {
      return false;
    }

    if (
      this.invoiceParams.isPrimaryReferenceRequired &&
      !this.hasNotChanged(
        this.pristineFormValue.selectedAssetReference,
        this.selectedAssetReference
      )
    ) {
      return true;
    }

    let pristAmount = '0';
    let changeAmount = '0';

    if (
      !_.isNil(this.pristineFormValue.AmountTaxExcluded) &&
      !_.isNil(this.invoiceDetailForm.controls.AmountTaxExcluded.value)
    ) {
      pristAmount = this.numberFormatPipe
        .transformfromString(
          this.pristineFormValue.AmountTaxExcluded.toString()
        )
        .toString();
      changeAmount = this.invoiceDetailForm.controls.AmountTaxExcluded.value
        ? this.numberFormatPipe
            .transform(this.invoiceDetailForm.controls.AmountTaxExcluded.value)
            .toString()
        : '0';
    }

    return !(
      this.hasNotChanged(
        this.pristineFormValue.selectedRecipientEntityId,
        this.selectedRecipientEntityId
      ) &&
      this.hasNotChanged(
        this.pristineFormValue.Number,
        this.invoiceDetailForm.value['Number']
      ) &&
      //this.invoiceParams.canManageInvoiceAGI
      (true
        ? this.hasNotChanged(
            this.pristineFormValue.SupplierCompanyName,
            this.invoiceDetailForm.value['SupplierCompanyName']
          )
        : this.hasNotChanged(
            this.pristineFormValue.SupplierEvaluaCompanyName,
            this.invoiceDetailForm.value['SupplierEvaluaCompanyName']
          )) &&
      this.hasNotChanged(pristAmount, changeAmount) &&
      this.hasNotChanged(
        this.pristineFormValue.SupplierSiren,
        this.invoiceDetailForm.value['SupplierSiren']
      ) &&
      this.hasNotChanged(
        this.pristineFormValue.SupplierSiret,
        this.invoiceDetailForm.value['SupplierSiret']
      )
    );
  }

  hasNotChanged(pristineValue: any, formValue: any): boolean {
    if (
      (_.isNil(pristineValue) || _.isEmpty(pristineValue)) &&
      (_.isNil(formValue) || _.isEmpty(formValue))
    ) {
      return true;
    }

    return pristineValue === formValue;
  }

  get selectedRecipientEntityId(): number {
    return !_.isEmpty(this.selectedRecipientEntity)
      ? _.head(this.selectedRecipientEntity)['Id']
      : null;
  }

  get selectedAssetReference(): string {
    return !_.isEmpty(this.selectedAsset)
      ? _.head(this.selectedAsset)['Label']
      : null;
  }

  get formControls(): { [key: string]: AbstractControl } {
    return this.invoiceDetailForm.controls;
  }

  get canChangeNumber(): boolean {
    return (
      !this.isReadOnlyForm &&
      (this.invoiceParams.isRejectedInvoice ||
        this.invoiceParams.isPendingForVoucherValidation ||
        this.invoiceParams.isInjection ||
        this.invoiceParams.isManual ||
        this.isPPRDirectInvoice ||
        this.isPPRWorkingSituation ||
        this.invoiceParams.isDuplicateInvoice)
    );
  }

  get isReadOnlyForm(): boolean {
    return (
      this.invoiceParams.isSearchDetail ||
      this.invoiceParams.isPendingForWorkflowCompletionVoucher ||
      this.invoiceParams.isPendingForWorkflowCompletionPromotion ||
      this.invoiceParams.isDuplicateInvoice ||
      (this.invoiceParams.isPendingForVoucherValidation &&
        !this.canValidateVoucher)
    );
  }

  get isReadOnlyFormOrWaiting(): boolean {
    return this.isReadOnlyForm || this.invoiceParams.isWaiting;
  }

  get canValidateVoucher(): boolean {
    if (
      !this.authenticationInfoService.authentificatedUser.GroupsMembership
        ?.NonERPComptabilityGroups?.length
    ) {
      return false;
    }

    return this.authenticationInfoService.authentificatedUser.GroupsMembership.NonERPComptabilityGroups.includes(
      this.invoiceDetailModel.Workflow.NonErpGroupId
    );
  }

  get lastForwardComment(): string {
    if (
      !this.authenticationInfoService.authentificatedUser.hasGrant(
        AccessRequirement.SupervisionMembership
      )
    ) {
      return '';
    }

    if (
      !this.invoiceDetailModel?.Assignments ||
      !this.invoiceDetailModel.Assignments.length
    ) {
      return '';
    }

    const assignmentsToSupervisor = this.invoiceDetailModel.Assignments.filter(
      (invoiceAssignment: InvoiceAssignmentGroupModel) =>
        invoiceAssignment.Type === GroupTypeModel.SUPERVISION
    );
    const lastAssignmentDate = Math.max(
      ...assignmentsToSupervisor.map((ia) => moment(ia.Date).unix())
    );
    const lastAssignment = assignmentsToSupervisor.find(
      (ia) => moment(ia.Date).unix() === lastAssignmentDate
    );
    return lastAssignment?.Comment ?? '';
  }

  //#region isEmptyField for messages

  get CanWaitInvoice(): boolean {
    this.setWaitingInvoice();
    return this.isWaitingInvoice;
  }

  setWaitingInvoice(): void {
    let result: boolean = false;
    if (this.isPPRDirectInvoice) {
      result =
        this.invoiceDetailModel.Expenses &&
        this.invoiceDetailModel.Expenses.filter((c) => _.isNil(c.FamilyCode))
          .length > 0;
    }
    result = result || this.isEmptyEvaluaCompanyName;
    this.isWaitingInvoice = result;
  }

  get isEmptyEvaluaCompanyName(): boolean {
    return (
      this.commonLibrary.isEmptyControl(
        this.formControls.SupplierEvaluaCompanyName
      ) &&
      !this.invoiceParams.canManageInvoiceAGI &&
      _.isNil(this.formControls.ClientIdPPR.value) &&
      _.isNil(this.formControls.GroupIdPPR.value)
    );
  }

  get CanProcessInvoice(): boolean {
    this.setProcessInvoice();
    return this.invoiceDetailModel.CanProcessInvoice;
  }

  setProcessInvoice(): void {
    let result: boolean = false;
    if (this.isPPRDirectInvoice) {
      result =
        this.invoiceDetailModel.Expenses &&
        this.invoiceDetailModel.Expenses.filter((c) => _.isNil(c.FamilyCode))
          .length > 0;
    } else if (this.isPPRWorkingSituation) {
      result =
        _.isNil(this.invoiceDetailModel.OperationId) ||
        _.isNil(this.invoiceDetailModel.SituationReference) ||
        _.isNil(this.invoiceDetailModel.SituationPeriode) ||
        _.isNil(this.invoiceDetailModel.VatCode) ||
        this.isAmountDifferent ||
        this.isAmountHTDifferent;
    }
    this.invoiceDetailModel.CanProcessInvoice = !result;
  }
  //#endregion

  buildFormControls() {
    var selectedInvoicePPRType = null;
    var selectedvat = null;

    if (this.invoiceDetailModel.IsPPR) {
      var selectedInvoicePPRType = this.invoiceDetailModel
        .IsForPPRDirectInvoiceBDC
        ? this.dropDownDataInvoicePPRType.find(
            (x) => x.Code == this.invoiceDetailModel.InvoicePPRType
          )
        : null;
      var selectedvat = this.invoiceDetailModel.IsWorkingSituation
        ? this.dropDownDataVat.find(
            (x) => x.Code == this.invoiceDetailModel.VatCode
          )
        : null;
    }

    if (!_.isNil(this.invoiceDetailModel.Number)) {
      this.invoiceDetailModel.SituationReference =
        this.invoiceDetailModel.SituationReference ??
        (this.invoiceDetailModel.Number.length > 50
          ? this.invoiceDetailModel.Number.slice(0, 50)
          : this.invoiceDetailModel.Number);
    }

    this.invoiceDetailForm = this.formGroupBuilder.buildFormControls(
      this.invoiceDetailModel,
      this.invoiceParams,
      this.isReadOnlyFormOrWaiting,
      this.isReadOnlyForm,
      this.canChangeNumber,
      this.shouldDisablePrimary,
      selectedInvoicePPRType,
      selectedvat,
      this.selectedRecipientEntity,
      this.selectedAsset
    );

    this.invoiceDetailForm.setValidators([this.dateRangeValidator]);

    if (this.isPPRWorkingSituation) {
      this.setAmountSituation(selectedvat?.Value);
      this.setSumInvoiceTaxIncluded();
    }
  }

  private dateRangeValidator: ValidatorFn = (): {
    [key: string]: any;
  } | null => {
    let invalid = false;
    const from =
      this.invoiceDetailForm && this.invoiceDetailForm.get('IssuedAt').value;
    const to =
      this.invoiceDetailForm && this.invoiceDetailForm.get('DueDate').value;
    if (from && to) {
      invalid = new Date(from).valueOf() > new Date(to).valueOf();
    }
    const invalidIssue = this.invoiceParams.isInjection
      ? false
      : invalid || !from;
    this.invoiceDetailForm.controls.IssuedAt.setErrors(
      invalidIssue
        ? {
            invalidRange: true,
          }
        : null
    );
    const invalidDue =
      this.invoiceParams.isManual || !this.invoiceParams.canCreateInPPR
        ? invalid
        : invalid || !to;
    this.invoiceDetailForm.controls.DueDate.setErrors(
      invalidDue
        ? {
            invalidRange: true,
          }
        : null
    );

    return invalid ? { invalidRange: { from, to } } : null;
  };

  setValidatorSupplierOrClient(withClientId: boolean, withGroupId: boolean = false) {
    if (!this.isReadOnlyForm) {
      this.invoiceParams.isInvoiceForClient =
        withClientId && this.isPPRDirectInvoice;

      this.invoiceParams.isInvoiceForGroup =
        withGroupId && (this.isPPRDirectInvoice || this.isPPRWorkingSituation);

      if (this.invoiceParams.isInvoiceForClient) {
          this.unSetValidatorGroup();
          this.unSetValidatorSupplier();
          this.onChangeEvaluaCompany(null);
          this.setClientValidators();
      } else if (this.invoiceParams.isInvoiceForGroup) {
          this.unSetValidatorClient();
          this.unSetValidatorSupplier();
          this.onChangeEvaluaCompany(null);
          this.setGroupValidators();
      } else {
          this.unSetValidatorClient();
          this.unSetValidatorGroup();
          this.setSupplierValidators();
      }
    }
  }

  setClientValidators() {
    this.invoiceDetailForm.controls.ClientIdPPR.setValidators([
        Validators.required,
        Validators.maxLength(7),
    ]);
    this.invoiceDetailForm.controls.ClientIdPPR.updateValueAndValidity();
  }

  setGroupValidators() {
    this.invoiceDetailForm.controls.GroupIdPPR.setValidators([
        Validators.required,
        Validators.maxLength(7),
        Validators.pattern(/[AG][A-Z0-9]{5,6}/),
    ]);
    this.invoiceDetailForm.controls.GroupIdPPR.updateValueAndValidity();
  }

  setSupplierValidators() {
    this.invoiceDetailForm.controls.SupplierEvaluaCompanyName.setValidators(
        !this.invoiceParams.isRejectedInvoice &&
        !this.invoiceParams.isInjection &&
        !this.invoiceParams.canManageInvoiceAGI
            ? [Validators.required]
            : []
    );
    this.invoiceDetailForm.controls.SupplierEvaluaCompanyName.updateValueAndValidity();
  }

  unSetValidatorSupplier(){
    this.invoiceDetailForm.controls.SupplierEvaluaCompanyName.setValidators(
      []
    );
    this.invoiceDetailForm.controls.SupplierEvaluaCompanyName.updateValueAndValidity();
    this.onChangeEvaluaCompany(null);
  }

  unSetValidatorClient() {
    this.invoiceDetailForm.controls.ClientIdPPR.setValidators([]);
    this.invoiceDetailModel.ClientIdPPR = null;
    this.invoiceDetailForm.controls.ClientIdPPR.setValue(null);
    this.invoiceDetailForm.controls.ClientIdPPR.updateValueAndValidity();
  }

  unSetValidatorGroup() {
    this.invoiceDetailForm.controls.GroupIdPPR.setValidators([]);
    this.invoiceDetailModel.GroupIdPPR = null;
    this.invoiceDetailForm.controls.GroupIdPPR.setValue(null);
    this.invoiceDetailForm.controls.GroupIdPPR.updateValueAndValidity();
  }

  onChangeClientIdPPR(value: any) {
    const newVal = _.isEmpty(value) || _.isNil(value) ? null : value;
    this.invoiceDetailModel.ClientIdPPR = newVal;

    this.setValidatorSupplierOrClient(!_.isNil(newVal));

    if (_.isNil(newVal))
      this.onChangeOperation({ id: this.invoiceDetailModel.OperationId });
  }

  onChangeGroupIdPPR(value: any) {
    const newVal = _.isEmpty(value) || _.isNil(value) ? null : value;
    this.invoiceDetailModel.GroupIdPPR = newVal;

    this.setValidatorSupplierOrClient(false, !_.isNil(newVal));
    
    if (_.isNil(newVal))
      this.onChangeOperation({ id: this.invoiceDetailModel.OperationId });
  }
  
  onChangeVatForSituation(selectedVat?: { Code: string } | null): void {
    this.editedDropdowns.push('VatCode');

    const vatDatas = _.find(
      this.dropDownDataVat,
      (x) => x?.Code === selectedVat?.Code
    );

    this.invoiceDetailForm.controls.VatCode.setValue(
      !_.isNil(vatDatas?.Value) ? [vatDatas?.Value] : []
    );
    this.invoiceDetailForm.controls.SelectedVat.setValue(
      !_.isNil(vatDatas?.Value) ? [vatDatas] : []
    );

    this.invoiceDetailModel.VatCode = vatDatas?.Code;
    this.invoiceDetailModel.VatLabel = vatDatas?.Label;
    this.invoiceDetailModel.VatValue = vatDatas?.Value;

    this.changeSituationDeductionAmountInformation(vatDatas?.Value);
  }

  changeSituationDeductionAmountInformation(tvavalue?: number) {
    this.childDeduction.setPercentage(
      this.selectedMarche,
      false,
      this.invoiceDetailAmountCalc.marketAndAmendmentsTaxIncluded
    );

    this.setAmountSituation(tvavalue);
    this.childAmendment.updateExpenseAmountForAllAmendment(tvavalue);

    this.childDeduction.setPercentage(
      this.selectedMarche,
      false,
      this.invoiceDetailAmountCalc.marketAndAmendmentsTaxIncluded
    );

    this.setSumInvoiceTaxIncluded();
  }

  //#region Expenses
  get InvoiceExpenses() {
    return this.invoiceDetailForm.controls[
      'InvoiceExpenses'
    ] as UntypedFormArray;
  }

  setExpensesChange(expenses: UntypedFormArray) {
    this.invoiceDetailForm.controls['InvoiceExpenses'] = expenses;

    this.expenseLibrary.setAmountFromExpense(
      this.invoiceDetailModel,
      this.invoiceDetailAmountCalc,
      this.invoiceDetailForm
    );
    this.updateChanges();
  }

  setExpensesChangePristine(expenses: UntypedFormArray) {
    this.invoiceDetailForm.controls['InvoiceExpenses'] = expenses;
    this.setPristine();
  }

  //#region Amendments
  get InvoiceAmendments() {
    return this.invoiceDetailForm.controls[
      'InvoiceAmendments'
    ] as UntypedFormArray;
  }

  get HasOneAmendments() {
    return this.invoiceDetailModel.Amendments.length > 0;
  }

  setAmendmentsChange(amendments: UntypedFormArray) {
    this.invoiceDetailForm.controls['InvoiceAmendments'] = amendments;
    this.setMandatoryFormField();
    this.updateChanges();
    this.setSumMarketWithAmendment();
  }

  setAmendmentsChangePristine(amendments: UntypedFormArray) {
    this.invoiceDetailForm.controls['InvoiceAmendments'] = amendments;
    this.setPristine();
  }

  setMandatoryFormField() {
    this.invoiceDetailForm.controls.AmountTaxExcludedWithoutAmendment.setValidators(
      this.shouldShowSituationWithAmendment ? [Validators.required] : []
    );

    if (!this.shouldShowSituationWithAmendment) {
      this.invoiceDetailModel.AmountTaxExcludedWithoutAmendment = null;
      this.invoiceDetailForm.controls.AmountTaxExcludedWithoutAmendment.setValue(
        null
      );
    }
    this.invoiceDetailForm.controls.AmountTaxExcludedWithoutAmendment.updateValueAndValidity();
  }
  //#endregion

  //#region Deductions
  get InvoiceDeductions() {
    return this.invoiceDetailForm.controls[
      'InvoiceDeductions'
    ] as UntypedFormArray;
  }

  setDeductionsChange(deductions: UntypedFormArray) {
    this.invoiceDetailForm.controls['InvoiceDeductions'] = deductions;
    this.updateChanges();
  }

  setDeductionsChangePristine(deductions: UntypedFormArray) {
    this.invoiceDetailForm.controls['InvoiceDeductions'] = deductions;
    this.setPristine();
  }
  //#endregion

  //#region Delegations
  get invoiceDelegations() {
    return this.invoiceDetailForm.controls[
      'InvoiceDelegations'
    ] as UntypedFormArray;
  }

  setDelegationsChange(delegations: UntypedFormArray) {
    this.invoiceDetailForm.controls['InvoiceDelegations'] = delegations;
    this.updateChanges();
  }

  setDelegationsChangePristine(delegations: UntypedFormArray) {
    this.invoiceDetailForm.controls['InvoiceDelegations'] = delegations;
    this.setPristine();
  }
  //#endregion

  goBackToInvoiceList(): void {
    if (_.isNil(this.invoiceViewType)) {
      this.router.navigate(['/invoices', InvoiceViewType.SEARCH]);
      return;
    }

    this.router.navigate(['/invoices', this.invoiceViewType]);
  }

  postActionCallBack = (actionType: InvoiceActionType, context?: any) => {
    switch (actionType) {
      case InvoiceActionType.ATTACH:
        break;

      case InvoiceActionType.PICK:
        this.invoiceDetailModel.PickedAt = new Date();
        this.invoiceDetailModel.PickedByUserId =
          this.authenticationInfoService.authentificatedUser.Id;
        this.invoiceDetailModel.PickedByUser =
          this.authenticationInfoService.authentificatedUser.FullName;
        break;

      case InvoiceActionType.UNPICK:
        this.invoiceDetailModel.PickedAt = null;
        this.invoiceDetailModel.PickedByUserId = null;
        this.invoiceDetailModel.PickedByUser = null;
        break;

      case InvoiceActionType.COMPLAINT:
        this.invoiceDetailModel.ComplaintAt = new Date();
        this.invoiceDetailModel.ComplaintByUserId =
          this.authenticationInfoService.authentificatedUser.Id;
        this.invoiceDetailModel.ComplaintByUser =
          this.authenticationInfoService.authentificatedUser.FullName;
        this.invoiceDetailModel.ComplaintComment = context;
        break;

      case InvoiceActionType.UNCOMPLAINT:
        this.invoiceDetailModel.ComplaintAt = null;
        this.invoiceDetailModel.ComplaintByUserId = null;
        this.invoiceDetailModel.ComplaintByUser = null;
        break;

      case InvoiceActionType.INJECTINVOICE:
        this.router.navigate(['/analysis/missing-invoice-numbers']);
        break;

      case InvoiceActionType.WAITING:
        this.router.navigate(['/invoices/waiting-voucher']);
        break;

      case InvoiceActionType.MANUAL:
        this.router.navigate(['/invoices/dispatched']);
        break;

      default:
        this.goBackToInvoiceList();
        break;
    }
  };

  uncheckInvoice = (): void => {
    this.InvoiceService.uncheckInvoice(this.invoiceDetailModel.Id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => (this.invoiceDetailModel.Checked = false));
  };

  private get shouldDisablePrimary(): boolean {
    return (
      this.isReadOnlyForm ||
      (!this.invoiceParams.isRejectedInvoice &&
        !this.invoiceParams.isDispatchedInvoice &&
        !this.invoiceParams.isControl &&
        !this.invoiceParams.isPendingForVoucherValidation &&
        !this.invoiceParams.isInjection &&
        !this.invoiceParams.isWaiting)
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }

  //#region Manage Check create in PPR
  onChangeCheck(checkvalue: boolean) {
    this.invoiceDetailModel.IsForPPRDirectInvoiceBDC = checkvalue;
    this.invoiceDetailModel.IsWorkingSituation = !checkvalue;

    this.invoiceDetailForm.controls.IsForPPRDirectInvoiceBDC.patchValue(
      this.invoiceDetailModel.IsForPPRDirectInvoiceBDC
    );
    this.invoiceDetailForm.controls.IsWorkingSituation.patchValue(
      this.invoiceDetailModel.IsWorkingSituation
    );

    this.emptyDirectOrBDCvsSituation(checkvalue);

    this.onChangeOperation({ id: this.invoiceDetailModel.OperationId }, false);
  }

  emptyDirectOrBDCvsSituation(IsForPPRDirectInvoiceBDC: boolean) {
    if (IsForPPRDirectInvoiceBDC) {
      // remove all informations from situation
      this.childAmendment.deleteAllAmendment();
      this.childDeduction.deleteAllDeduction();
      this.childDelegation.deleteAllDelegation();

      // Init array expenses
      this.invoiceDetailModel.Expenses = [];
    } else {
      // remove all informations from DirectInvoiceOrBDC
      this.childExpense.deleteAllExpense();

      // Init array for situation
      this.invoiceDetailModel.Amendments = [];
      this.invoiceDetailModel.Deductions = [];
      this.invoiceDetailModel.Delegations = [];
    }

    this.formGroupBuilder.setRequiredDirectInvoice(
      this.invoiceDetailModel,
      this.invoiceDetailForm,
      IsForPPRDirectInvoiceBDC
    );
    this.formGroupBuilder.setRequiredWorkingSituation(
      this.invoiceDetailModel,
      this.invoiceDetailForm,
      !IsForPPRDirectInvoiceBDC
    );
  }
  //#endregion

  shouldShowCheckCreateInPPR() {
    return (
      this.invoiceParams.canCreateInPPR && !this.invoiceParams.isRejectedInvoice
    );
  }

  get shouldShowDirectOrBDC(): boolean {
    return (
      this.invoiceParams.canCreateInPPR &&
      this.invoiceDetailModel.IsForPPRDirectInvoiceBDC &&
      !this.invoiceParams.isRejectedInvoice
    );
  }

  get shouldShowSituation(): boolean {
    return (
      this.invoiceParams.canCreateInPPR &&
      this.invoiceDetailModel.IsWorkingSituation &&
      !this.invoiceParams.isRejectedInvoice
    );
  }

  get shouldShowSituationWithAmendment(): boolean {
    return this.invoiceDetailModel.Amendments.length > 0;
  }

  setMonthAndYear(
    normalizedMonthAndYear: moment.Moment,
    datepicker: MatDatepicker<moment.Moment>
  ) {
    this.setsetMonthAndYearCalculated(normalizedMonthAndYear);
    datepicker.close();
  }

  setMonthAndYearManually() {
    const normalizedMonthAndYear =
      this.invoiceDetailForm.controls.SituationPeriode.value;
    this.setsetMonthAndYearCalculated(normalizedMonthAndYear);
  }

  setsetMonthAndYearCalculated(normalizedMonthAndYear: moment.Moment) {
    var formated = !_.isNil(normalizedMonthAndYear)
      ? moment(normalizedMonthAndYear).format('YYYY-MM-15')
      : null;
    this.invoiceDetailForm.controls.SituationPeriode.setValue(formated);
    this.invoiceDetailModel.SituationPeriode = formated;
  }

  getColorDirtyOrNotForClient(dirty: boolean, enabled: boolean): string {
    if (
      (this.isReadOnlyFormOrWaiting && !enabled) ||
      !this.invoiceParams.isInvoiceForClient
    ) {
      return this.field_disabled;
    }
    return dirty ? this.field_change : this.field_read;
  }

  getColorDirtyOrNotForGroup(dirty: boolean, enabled: boolean): string {
    if (
      (this.isReadOnlyFormOrWaiting && !enabled) ||
      !this.invoiceParams.isInvoiceForGroup
    ) {
      return this.field_disabled;
    }
    return dirty ? this.field_change : this.field_read;
  }

  getColorDirtyOrNot(dirty: boolean, enabled: boolean): string {
    if (this.isReadOnlyFormOrWaiting && !enabled) {
      return this.field_disabled;
    }
    return dirty ? this.field_change : this.field_read;
  }

  setSumInvoiceTaxIncluded() {
    const InvoiceSumTaxIncluded =
      this.numberFormatPipe.transformfromString(
        this.invoiceDetailAmountCalc.marketAndAmendmentsTaxIncluded
      ) -
      this.numberFormatPipe.transformfromString(
        this.invoiceDetailAmountCalc.deductionsSumProvisionedTaxExcludedWithSign
      ) +
      this.numberFormatPipe.transformfromString(
        this.invoiceDetailAmountCalc.deductionsSumReleasedTaxExcluded
      );

    this.invoiceSumTaxIncluded = this.decimalPipe.transform(
      InvoiceSumTaxIncluded,
      '1.2-2'
    );
  }

  setSumMarketWithAmendment() {
    this.invoiceDetailModel.AmountTaxExcludedWithoutAmendment = _.isNil(
      this.invoiceDetailForm.controls.AmountTaxExcludedWithoutAmendment.value
    )
      ? 0
      : this.invoiceDetailForm.controls.AmountTaxExcludedWithoutAmendment.value;

    const InvoiceSumMarketWithAmendment =
      this.numberFormatPipe.transformfromString(
        this.invoiceDetailAmountCalc.amendmentsSumTaxExcluded
      ) +
      this.numberFormatPipe.transformfromString(
        this.invoiceDetailModel.AmountTaxExcludedWithoutAmendment.toString()
      );

    this.invoiceDetailAmountCalc.invoiceSumMarketWithAmendment =
      this.decimalPipe.transform(InvoiceSumMarketWithAmendment, '1.2-2');
  }

  setSumInvoice() {
    var selectedvat = this.invoiceDetailModel.IsWorkingSituation
      ? this.dropDownDataVat.find(
          (x) => x.Code == this.invoiceDetailModel.VatCode
        )
      : null;

    const vatValue = !_.isNil(this.invoiceDetailModel.VatValue)
      ? this.invoiceDetailModel.VatValue
      : selectedvat.Value;

    this.invoiceDetailModel.AmountTaxExcluded =
      this.invoiceDetailForm.controls.AmountTaxExcluded.value;
    if (!_.isNil(vatValue)) {
      this.changeSituationDeductionAmountInformation(toNumber(vatValue));
    }
  }

  setAmountSituation(tvavalue: number) {
    if (!_.isNil(tvavalue)) {
      const amountTaxExcluded: number = this.numberFormatPipe.transform(
        this.invoiceDetailModel.AmountTaxExcluded
      );
      const AmountVat = (amountTaxExcluded * tvavalue) / 100;
      const AmountTaxIncluded = amountTaxExcluded + AmountVat;

      this.invoiceDetailAmountCalc.marketAndAmendmentsVAT =
        this.decimalPipe.transform(AmountVat, '1.2-2');
      this.invoiceDetailAmountCalc.marketAndAmendmentsTaxIncluded =
        this.decimalPipe.transform(AmountTaxIncluded, '1.2-2');
    } else {
      this.invoiceDetailAmountCalc.marketAndAmendmentsVAT =
        this.decimalPipe.transform(0, '1.2-2');
      this.invoiceDetailAmountCalc.marketAndAmendmentsTaxIncluded =
        this.decimalPipe.transform(0, '1.2-2');
    }
  }

  get isAmountDifferent(): boolean {
    return (
      this.numberFormatPipe.transformfromString(this.invoiceSumTaxIncluded) !=
      this.numberFormatPipe.transformfromString(
        this.invoiceDetailForm.controls.AmountTaxIncluded.value
      )
    );
  }

  get isAmountHTDifferent(): boolean {
    if (!this.shouldShowSituationWithAmendment) {
      return false;
    }
    if (
      !this.invoiceDetailAmountCalc.invoiceSumMarketWithAmendment ||
      !this.invoiceDetailForm.controls.AmountTaxExcluded
    ) {
      return true;
    }
    return (
      this.numberFormatPipe.transformfromString(
        this.invoiceDetailAmountCalc.invoiceSumMarketWithAmendment
      ) !=
      this.numberFormatPipe.transformfromString(
        this.invoiceDetailForm.controls.AmountTaxExcluded.value
      )
    );
  }

  get isPPRDirectInvoice(): boolean {
    return (
      this.invoiceDetailModel.IsPPR &&
      this.invoiceDetailModel.IsForPPRDirectInvoiceBDC &&
      !this.invoiceParams.isRejectedInvoice
    );
  }

  get isPPRWorkingSituation(): boolean {
    return (
      this.invoiceDetailModel.IsPPR &&
      this.invoiceDetailModel.IsWorkingSituation &&
      !this.invoiceParams.isRejectedInvoice
    );
  }

  get isComplaintInvoice(): boolean {
    return !_.isNil(this.invoiceDetailModel.ComplaintByUserId);
  }

  //#region concat Fields

  collectMarcheConcatRowColumns(collector, row: Marche) {
    row.label = row.idCorpsMetier
      .toString()
      .concat(' - ', row.libelleCorpsMetier);
    return collector;
  }

  collectAvenantConcatRowColumns(collector, row: Avenant) {
    row.label = row.numeroAvenant
      .toString()
      .concat(' - ', row.libelleTypeAvenant)
      .concat(' (', row.libelleTypeTS, ')');
    return collector;
  }

  collectCommandeConcatRowColums(collector, row: Commande) {
    row.numeroInterneWithLabel = row.numeroInterne
      .toString()
      .concat(' : ', row?.lignes[0].libelle);
    return collector;
  }

  //#endregion

  //#region get Search Param for DataWell

  getParamFor_searchOperationWithGlobalParam(
    searchValue: string
  ): SearchGlobalParam {
    const selectedField: string[] = [
      'id',
      'nom',
      'societe.idSociete',
      'entiteJuridique.formeJuridique.nomFormeJuridique',
      'entiteJuridique.nomEntiteJuridique',
      'entiteComptable.idEntiteComptable',
    ];

    return new SearchGlobalParam(20, selectedField, 'nom', [
      new SearchParam('id', SearchParamOperator.LIKE, [searchValue]),
    ]);
  }

  getParamFor_searchCommandeWithGlobalParam(
    idOperation: string,
    fournisseur: string
  ): SearchGlobalParam {
    const selectedField: string[] = [
      'id',
      'numeroInterne',
      'creancier',
      'montantHT',
      'lignes',
      'delai.idDelai',
      'condition.idCondition',
    ];

    let params: SearchGlobalParam = new SearchGlobalParam(
      null,
      selectedField,
      'id',
      [
        new SearchParam('idOperation', SearchParamOperator.EQUALS, [
          idOperation,
        ]),
        new SearchParam('fournisseur', SearchParamOperator.EQUALS, [
          fournisseur,
        ]),
      ]
    );

    if (!this.isReadOnlyForm) {
      params.request.push(
        new SearchParam(
          'totalementConsommee',
          SearchParamOperator.EQUALS,
          ['false'],
          'boolean'
        )
      );
    }

    return params;
  }

  getParamFor_searchMarcheWithGlobalParam(
    idOperation: string,
    fournisseur: string
  ): SearchGlobalParam {
    const selectedField: string[] = [
      'idMarche',
      'corpsMetier.idCorpsMetier',
      'corpsMetier.libelleCorpsMetier',
      'montantHT',
      'idCession',
      'retenueGarantie',
      'retenueProrata',
      'retenuePilotage',
      'retenueFinale',
      'delai.idDelai',
      'condition.idCondition',
    ];

    return new SearchGlobalParam(null, selectedField, 'id', [
      new SearchParam('idOperation', SearchParamOperator.EQUALS, [idOperation]),
      new SearchParam('idTiers', SearchParamOperator.EQUALS, [fournisseur]),
    ]);
  }

  getParamFor_searchAvenantWithGlobalParam(
    idOperation: string,
    idMarche: string
  ): SearchGlobalParam {
    const selectedField: string[] = [
      'idMarche',
      'idAvenant',
      'numeroAvenant',
      'typeAvenant.libelleTypeAvenant',
      'typeTS.libelleTypeTS',
      'montantHT',
      'description1',
    ];

    return new SearchGlobalParam(null, selectedField, null, [
      new SearchParam('idOperation', SearchParamOperator.EQUALS, [idOperation]),
      new SearchParam('idMarche', SearchParamOperator.EQUALS, [idMarche]),
    ]);
  }

  getParamFor_searchAvancementAvenantWithGlobalParam() {
    const idsAvenant: string[] = [
      ...this.dropDownDataAvenant.map((c) => c.idAvenant),
    ];
    const selectedField: string[] = ['idAvenant', 'montantHT', 'cumulHT'];

    return new SearchGlobalParam(null, selectedField, null, [
      new SearchParam('idAvenant', SearchParamOperator.IN, idsAvenant),
    ]);
  }

  getParamFor_searchTierWithGlobalParam(
    searchValues: string[]
  ): SearchGlobalParam {
    const selectedField: string[] = ['idTiers', 'idCompta'];

    return new SearchGlobalParam(null, selectedField, null, [
      new SearchParam('idTiers', SearchParamOperator.IN, searchValues),
    ]);
  }

  //#endregion
}
